<portal-modal-header [variant]="variant" (onClose)="dismiss.emit()">
  <ng-template [ngTemplateOutlet]="header" portalTransclude="header"></ng-template>
</portal-modal-header>
